var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024.003",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M984 0H688.424c-22.092 0-40 17.91-40 40s17.908 40 40 40H887.43L566.788 400.646c-15.622 15.622-15.622 40.948 0 56.568 15.62 15.62 40.946 15.622 56.568 0L944 136.57v199.005c0 22.092 17.908 40 40 40s40-17.908 40-40V40c0-21.77-17.692-40-40-40zM457.212 566.79c-15.622-15.62-40.948-15.623-56.568 0L80 887.432V688.427c0-22.092-17.908-40-40-40s-40 17.908-40 40V984c0 21.733 17.706 40 40 40h295.576c22.092 0 40-17.907 40-40s-17.908-40-40-40H136.568l320.644-320.643c15.622-15.622 15.622-40.948 0-56.568z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResize);
export default __webpack_public_path__ + "static/media/resize.21fee4c1aa5875fc9778ec167a200907.svg";
export { ForwardRef as ReactComponent };